var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "page-integrations" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.integrations") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "integration-nav" }, [
        _c("div", { staticClass: "big-title" }, [
          _vm._v(_vm._s(_vm.$t("message.allIntegrations"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-items" },
          _vm._l(_vm.integrationGroups, function (group, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "nav-item",
                class: { active: _vm.activeGroup === group.id },
                attrs: { href: "#" + group.id },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.scrollToGroup(group.id)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons",
                    style: { color: group.color },
                  },
                  [_vm._v(_vm._s(group.icon))]
                ),
                _vm._v(
                  "\n                " + _vm._s(group.title) + "\n            "
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "pl-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "social-media" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.socialMedia")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _vm.multiWhatsapp &&
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                    ) &&
                    _vm.istWhatsappV2()
                      ? _c(
                          "div",
                          {
                            staticClass: "story whatsapp-story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "integrations/whatsapp-v2"
                                )
                              },
                            },
                          },
                          [
                            _vm.whatsappV2ChannelExists
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "compare-button",
                                on: { click: _vm.openWhatsappComparison },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("compare"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("Kıyasla")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img whatsapp" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "material-icons star-v2" },
                                  [_vm._v(" star ")]
                                ),
                                _vm._v(" "),
                                _c("WhatsappV2", {
                                  staticStyle: { width: "40px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("WhatsApp V2 (Web)"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("message.integrationsWhatsappV2")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story whatsapp-story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/whatsapp-v3")
                          },
                        },
                      },
                      [
                        _vm.whatsappV3ChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "compare-button",
                            on: { click: _vm.openWhatsappComparison },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("compare"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Kıyasla")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img whatsapp" },
                          [
                            _c("WhatsappV3Icon", {
                              staticStyle: { width: "40px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("WhatsApp V3 (QR Code)"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.integrationsWhatsappV2")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story whatsapp-story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "integrations/whatsapp-business-api"
                                )
                              },
                            },
                          },
                          [
                            _vm.whatsappBusinessChannelExists
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "compare-button",
                                on: { click: _vm.openWhatsappComparison },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("compare"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("Kıyasla")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img whatsapp" },
                              [
                                _c("WhatsappBusinessIcon", {
                                  staticStyle: { width: "50px" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("WhatsApp Business API"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrationsWhatsappBusiness"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/instagram")
                          },
                        },
                      },
                      [
                        _vm.instagramChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img instagram" },
                          [_c("InstagramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Instagram"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.integrationsInstagram")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/messenger")
                          },
                        },
                      },
                      [
                        _vm.messengerChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img messenger" },
                          [_c("FacebookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Messenger"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("message.messengerIntegrationDesc")
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/linkedin")
                          },
                        },
                      },
                      [
                        _vm.linkedinChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img linkedin" },
                          [_c("LinkedinIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Linkedin"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.integrationsLinkedin")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/telegram-qr")
                          },
                        },
                      },
                      [
                        _vm.telegramChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img telegram" },
                          [_c("TelegramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Telegram (QR Code)"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.integrationsTelegram")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["integrations.telegram.view"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story",
                            on: {
                              click: function () {
                                return _vm.telegramEnabled
                                  ? _vm.createTelegramChannel()
                                  : _vm.$feature.beforeCreateIntegrationChannel(
                                      _vm.createTelegramChannel,
                                      "telegram"
                                    )
                              },
                            },
                          },
                          [
                            _vm.telegramEnabled
                              ? _c("div", { staticClass: "status" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v(" done ")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("message.installationOK")) +
                                      "\n                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-modal",
                              {
                                attrs: {
                                  title: _vm.$t("telegram.telegramTokenTitle"),
                                  wrapClassName: "vertical-center-modal",
                                  visible: _vm.integrateTelegramModalVisible,
                                },
                                on: {
                                  cancel: function ($event) {
                                    return _vm.handleCancel()
                                  },
                                  ok: function ($event) {
                                    return _vm.handleOk()
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col mb-5" },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "telegram.typeInTelegramToken"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "a-modal",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "telegram.telegramAlertTitle"
                                              ),
                                            },
                                            on: {
                                              ok: _vm.confirmDeleteToken,
                                              cancel: _vm.cancelDeleteToken,
                                            },
                                            model: {
                                              value: _vm.visibleDeleteToken,
                                              callback: function ($$v) {
                                                _vm.visibleDeleteToken = $$v
                                              },
                                              expression: "visibleDeleteToken",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "telegram.telegramAlertText"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "row mb-3" },
                                          [
                                            _c("a-input", {
                                              staticClass: "mt-2",
                                              class: {
                                                "err-class": _vm.showWarning,
                                              },
                                              staticStyle: { width: "90%" },
                                              attrs: {
                                                autofocus: "",
                                                placeholder:
                                                  _vm.$t("telegram.token"),
                                              },
                                              on: {
                                                change:
                                                  _vm.onTelegramTokenChange,
                                              },
                                              model: {
                                                value: _vm.tempToken,
                                                callback: function ($$v) {
                                                  _vm.tempToken = $$v
                                                },
                                                expression: "tempToken",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm.isThereTempToken
                                              ? _c("a-button", {
                                                  staticClass: "ml-2 p-10 mt-2",
                                                  attrs: {
                                                    type: "primary",
                                                    icon: "delete",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.showDeleteConfirmation,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-alert",
                                      {
                                        attrs: {
                                          "show-icon": "",
                                          type: "info",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "description" },
                                            slot: "description",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "telegram.telegramAlertForm"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "https://t.me/BotFather",
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v("BotFather")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img telegram" },
                              [_c("TelegramIcon")],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("Telegram (Bot Father)"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("message.integrationsTelegram")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "web" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.web")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "/integrations/webchat/bubble-settings"
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "status" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" done "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.installationOK")) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img supsis" },
                          [_c("SupsisIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.chatWidget"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.integrationsWebchat")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webhook")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img webhooks" },
                          [_c("WebhookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.webhooks"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrateSupsiswithIntegratable",
                                  { integratable: "Webhooks" }
                                )
                              ) +
                              " .\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webtabs")
                          },
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Web Sekmeler"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            Sidebar menüye özel sekmeler ekleyerek dış uygulamaları Supsis içinde açın\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webapps")
                          },
                        },
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Web Apps"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            Kendi web uygulamalarınızı yükleyin ve yönetin\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "email" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _vm.isEmailFeatureEnabled()
                      ? _c(
                          "div",
                          {
                            staticClass: "story",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("integrations/mail")
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "img mail" },
                              [_c("DynamicSvg", { attrs: { name: "Mail" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("Mail"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.integrateSupsiswithIntegratable",
                                      { integratable: "Mail" }
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "sms" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.sms")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/sms/postacell"
                            )
                          },
                        },
                      },
                      [
                        _vm.smsChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("SMS - Postacell"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsSMSPostacell"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "crm" } },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.crm")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/bitrix24")
                          },
                        },
                      },
                      [
                        _vm.bitrixChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img ideasoft" },
                          [_c("BitrixIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Bitrix24"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsBitrix24"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/zoho")
                          },
                        },
                      },
                      [
                        _vm.zohoChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img ideasoft" },
                          [_c("ZohoIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Zoho CRM"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(_vm.$t("message.integrationsZoho"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/teamgram")
                          },
                        },
                      },
                      [
                        _vm.teamgramChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img teamgram" },
                          [_c("TeamGramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Teamgram"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsTeamgram"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "e-commerce" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.ecommerce")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ideasoft")
                          },
                        },
                      },
                      [
                        _vm.ideasoftChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img ideasoft" },
                          [_c("IdeasoftIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Ideasoft"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsIdeasoft"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ticimax")
                          },
                        },
                      },
                      [
                        _vm.ticimaxChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Ticimax"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(_vm.$t("message.integrationsTicimax"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/ticimax-v2")
                          },
                        },
                      },
                      [
                        _vm.ticimaxChannelsV2.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Ticimax-V2"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "Ticimax mağaza bilgilerinizi Supsis üzerinden kolayca yönetmenizi ve müşterilerinize anlık yanıtlar vermenizi sağlar."
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/trendyol")
                          },
                        },
                      },
                      [
                        _vm.trendyolChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img" },
                          [_c("TrendyolIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.trendyol"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsTrendyol"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/t-soft")
                          },
                        },
                      },
                      [
                        _vm.tsoftChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "img" }, [_c("TsoftIcon")], 1),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [_vm._v("T-SOFT")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                            T-SOFT Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/ikas")
                          },
                        },
                      },
                      [
                        _vm.ikasChannelExists.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "img",
                            staticStyle: { background: "#deff37" },
                          },
                          [_c("IkasIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [_vm._v("IKAS")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                            Ikas Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "utilities" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.utilities")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/integrations/webhook")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img webhooks" },
                          [_c("WebhookIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("message.webhooks"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrateSupsiswithIntegratable",
                                  { integratable: "Webhooks" }
                                )
                              ) +
                              " .\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/cache-manager")
                          },
                        },
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("Cache Manager"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                            Otomasyon ve chatbot'lar arası veri paylaşımı için cache yönetimi\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/openai")
                          },
                        },
                      },
                      [
                        _vm.openaiChannels.length > 0
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img" },
                          [_c("OpenaiIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [_vm._v("OpenAI")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("message.integrationsOpenAI"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "integration-group",
                  attrs: { id: "advertising" },
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("message.advertising")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stories" }, [
                    _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/meta-leads")
                          },
                        },
                      },
                      [
                        _vm.metaLeadsChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img meta" },
                          [_c("MetaIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Meta Leads"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.integrationsMetaLeads"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "integration-group", attrs: { id: "ses" } },
                [
                  _c("h3", [_vm._v("Ses")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "stories" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/redsantral"
                              )
                            },
                          },
                        },
                        [
                          _vm.webphoneChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("Webphone (Kırmızı Santral)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v("Web tabanlı telefon sistemi entegrasyonu"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/telnyx"
                              )
                            },
                          },
                        },
                        [
                          _vm.telnyxChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(7),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("Webphone (Telnyx)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "Global arama yapabilmek için Telnyx entegrasyonu"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "story",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/integrations/webphone/netgsm"
                              )
                            },
                          },
                        },
                        [
                          _vm.netgsmChannelExists
                            ? _c("div", { staticClass: "status" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" done "),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.installationOK")) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v("Webphone (NetGSM)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "NetGSM santral sistemi ile web tabanlı telefon entegrasyonu"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.get"] } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "story",
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push(
                                    "integrations/voice-agent"
                                  )
                                },
                              },
                            },
                            [
                              _vm.retellChannelExists
                                ? _c("div", { staticClass: "status" }, [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v(" done ")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("message.installationOK")
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "img retell" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("record_voice_over"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "title" }, [
                                _vm._v("AI Voice Agent"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description" }, [
                                _vm._v(
                                  "\n                                Telefonlarınızı sesli yapay zeka asistanı ile yönetin. Ayrıca web sitesinize sesli\n                                asistan entegre edebilirsiniz.\n                            "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "custom-modal whatsapp-comparison-modal",
          attrs: {
            visible: _vm.whatsappComparisonModalVisible,
            "cancel-text": null,
            width: 1400,
            footer: false,
            "footer-hide": true,
            title: "WhatsApp Çözümleri Karşılaştırması",
          },
          on: {
            "update:visible": function ($event) {
              _vm.whatsappComparisonModalVisible = $event
            },
            ok: function () {
              return (_vm.whatsappComparisonModalVisible = false)
            },
            cancel: function ($event) {
              _vm.whatsappComparisonModalVisible = false
            },
          },
        },
        [_c("WhatsappComparison")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webtabs" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("tab")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webapps" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("web")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img postacell" }, [
      _c("img", { attrs: { src: "/static/img/postacell-logo.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ticimax" }, [
      _c("div", { staticClass: "img postacell" }, [
        _c("img", { attrs: { src: "/static/img/ticimax.png" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img ticimax" }, [
      _c("div", { staticClass: "img postacell" }, [
        _c("img", { attrs: { src: "/static/img/ticimax.png" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img cache" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("storage")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img webphone" }, [
      _c(
        "span",
        { staticClass: "material-icons", staticStyle: { color: "#d32f2f" } },
        [_vm._v("phone")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img telnyx" }, [
      _c("img", {
        staticStyle: { width: "40px", height: "40px" },
        attrs: { src: "/static/img/telnyx.png", alt: "Telnyx" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img netgsm" }, [
      _c("img", {
        staticStyle: { width: "40px", height: "40px" },
        attrs: { src: "/static/img/netgsm.png", alt: "NetGSM" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }